import React from 'react';
import ManagePrices from './managePrices';

const Prices = () => {
  return (
    <div>
      <ManagePrices />
    </div>
  );
};

export default Prices;
